import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiAnnouncement, ApiAnnouncementResponse, ApiAvatar, ApiLocation, ApiSavedAnnouncementSearch, ApiUser } from '@app/packages/api/v2/types/entities'
import type { ApiDataResponse, SavedAnnouncementSearchesByIdAnnouncemenetsMeta } from '@app/packages/api/v2/types/misc'
import type {
  SavedAnnouncementSearchesByIdAnnouncemenetsQuery,
  SavedAnnouncementSearchPostRequest,
  SavedAnnouncementSearchPutRequest,
} from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getSavedAnnouncementSearches = () =>
  createApiAction('getSavedAnnouncementSearches', dispatch =>
    dispatch<ApiDataResponse<ApiSavedAnnouncementSearch[]>>({ method: 'GET', endpoint: '/api/v2/saved_announcement_searches' })
  )

export const getSavedAnnouncementSearchesById = (id: string) =>
  createApiAction('getSavedAnnouncementSearchesById', dispatch =>
    dispatch<ApiDataResponse<ApiSavedAnnouncementSearch>>({ method: 'GET', endpoint: urlEscaped`/api/v2/saved_announcement_searches/${id}` })
  )

export const postSavedAnnouncementSearches = (request: SavedAnnouncementSearchPostRequest) =>
  createApiAction('postSavedAnnouncementSearches', dispatch =>
    dispatch<ApiDataResponse<ApiSavedAnnouncementSearch>>({
      method: 'POST',
      endpoint: '/api/v2/saved_announcement_searches',
      body: JSON.stringify(request),
    })
  )

export const putSavedAnnouncementSearchesById = (id: string, request: SavedAnnouncementSearchPutRequest) =>
  createApiAction('putSavedAnnouncementSearchesById', dispatch =>
    dispatch<ApiDataResponse<ApiSavedAnnouncementSearch>>({
      method: 'PUT',
      endpoint: urlEscaped`/api/v2/saved_announcement_searches/${id}`,
      body: JSON.stringify(request),
    })
  )

export const deleteSavedAnnouncementSearchesById = (id: string) =>
  createApiAction('deleteSavedAnnouncementSearchesById', dispatch =>
    dispatch<unknown>({ method: 'DELETE', endpoint: urlEscaped`/api/v2/saved_announcement_searches/${id}` })
  )

export const getSavedAnnouncementSearchesByIdAnnouncements = (id: string, query: SavedAnnouncementSearchesByIdAnnouncemenetsQuery) =>
  createApiAction('getSavedAnnouncementSearchesByIdAnnouncements', dispatch =>
    dispatch<{
      data: ApiAnnouncement[]
      included?: (ApiUser | ApiLocation | ApiAvatar | ApiAnnouncementResponse)[]
      meta: SavedAnnouncementSearchesByIdAnnouncemenetsMeta
    }>({ method: 'GET', endpoint: v2Path(urlEscaped`/api/v2/saved_announcement_searches/${id}/announcements`, query) })
  )
